import { Pipe, PipeTransform } from '@angular/core';

const TAG_PALETTE = {
  at: 'var(--skylark-tag-at)',
  ct: 'var(--skylark-tag-ct)',
  safepass: 'var(--skylark-tag-safepass)',
  access: 'var(--skylark-tag-access)',
  firstaid: 'var(--skylark-tag-access)',
  hvc1: 'var(--skylark-tag-hvc-1)',
  substation: 'var(--skylark-tag-substation)',
};

const TAG_FALLBACK_PALETTE = [
  'var(--skylark-tag-1)',
  'var(--skylark-tag-2)',
  'var(--skylark-tag-3)',
  'var(--skylark-tag-4)',
  'var(--skylark-tag-5)',
  'var(--skylark-tag-6)',
  'var(--skylark-tag-7)',
];

function normalizeKey(value: string): string {
  return value.toLowerCase().replace(/[\s-]+/g, '');
}

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
}

@Pipe({ name: 'competencyBadgeColor' })
export class CompetencyBadgeColorPipe implements PipeTransform {
  transform(competencyName: string): string {
    const nameKey = normalizeKey(competencyName || '');
    if (nameKey && TAG_PALETTE[nameKey]) {
      return TAG_PALETTE[nameKey];
    }
    const index = hashString(nameKey) % TAG_FALLBACK_PALETTE.length;
    return TAG_FALLBACK_PALETTE[index];
  }
}
